import { miniCartLyonStyling } from "@made-people/blueprint-mini-cart/blueprint";

miniCartLyonStyling.override({
  slots: {
    base: "flex flex-col lg:h-full max-h-[calc(100dvh-64px)] lg:max-h-none group/mini-cart lg:w-[600px] mini-cart",
    header: "justify-center pb-4 lg:pb-6 border-b border-border mb-4 lg:mb-6",
    close: "absolute top-6 right-6",
    cartItemsWrapper:
      "lg:max-h-none overflow-y-scroll border-b border-text-body-less-emphasis-3",
    cartTotalsWrapper: "flex flex-col gap-4 mt-4",
    emptyCartWrapper:
      "flex flex-col gap-6 items-center justify-center h-[70%] min-h-[300px]",
    emptyCartMessage: "text-heading-md lg:text-heading-lg",
    trustLogosBannerWrapper: "flex justify-center mt-2 order-5 empty:hidden",
  },
});
